import { render, staticRenderFns } from "./CompanyInfo.vue?vue&type=template&id=2bcdbd28&scoped=true"
import script from "./CompanyInfo.vue?vue&type=script&lang=js"
export * from "./CompanyInfo.vue?vue&type=script&lang=js"
import style0 from "./CompanyInfo.vue?vue&type=style&index=0&id=2bcdbd28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcdbd28",
  null
  
)

export default component.exports